document.addEventListener("DOMContentLoaded", function () {
  function getCartValue() {
    const totalSpan = document.querySelector(".totals__subtotal-value");
    if (!totalSpan) return 0;
    const text = totalSpan.textContent.trim();
    const numericValue = text
      .replace(/[€\s]/g, "")
      .replace("EUR", "")
      .replace(/\./g, "")
      .replace(",", ".");
    return parseFloat(numericValue) || 0;
  }

  // Listener per i bottoni Add to Cart nelle product card
  const atcButtons = document.querySelectorAll(".product_card__atc");
  atcButtons.forEach((atcBtn) => {
    atcBtn.addEventListener("click", function () {
      const variantSku = atcBtn.dataset.variantSku ?? '';
      const variantTitle = atcBtn.dataset.variantTitle;
      const variantVendor = atcBtn.dataset.variantVendor;
      const variantPrice = parseFloat(atcBtn.dataset.variantPrice) || 0;
      const variantDiscount = parseFloat(atcBtn.dataset.variantDiscount) || 0;

      const cartValue = getCartValue();

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: "EUR",
          value: cartValue,
          items: [
            {
              item_name: variantTitle,
              item_id: variantSku,
              price: variantPrice,
              item_brand: variantVendor,
              quantity: 1,
              discount: variantDiscount,
            },
          ],
        },
      });
    });
  });
});
